// import createRavenMiddleware from 'raven-for-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { refreshAccessTokenMiddleware } from './actions/session';
import rootReducer from './reducers';

const composeEnhancer = ((typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : undefined) || compose;

const configureStore = (preloadedState) => {
  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancer(applyMiddleware(
      refreshAccessTokenMiddleware,
      thunk,
      // createRavenMiddleware(Raven, {}),
    )),
  );

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default;

      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default configureStore;
